package top.wcpe.allincore.ui.web.preview

/**
 * FR-UI-065 预览应用的纯路径 / 判定逻辑（无浏览器 IO，jsNodeTest 单测）。
 */

/** 由 .allin 源路径推导同目录 mock 文件路径（`<同名>.mock.json`，FR-UI-064 约定）。 */
internal fun mockPathOf(allinPath: String): String {
    val base = if (allinPath.endsWith(".allin")) allinPath.removeSuffix(".allin") else allinPath
    return "$base.mock.json"
}

/** 取路径最后一段作显示名（用于诊断浮层标题 / session 名）。 */
internal fun displayNameOf(allinPath: String): String {
    val normalized = allinPath.trimEnd('/')
    val slash = normalized.lastIndexOf('/')
    return if (slash >= 0) normalized.substring(slash + 1) else normalized
}

/** 从 window.location.search 取指定参数（无则 null）；已解码。 */
internal fun queryParam(search: String, key: String): String? {
    val q = search.removePrefix("?")
    if (q.isEmpty()) return null
    for (pair in q.split("&")) {
        val eq = pair.indexOf('=')
        val k = if (eq >= 0) pair.substring(0, eq) else pair
        if (k == key) {
            val raw = if (eq >= 0) pair.substring(eq + 1) else ""
            return decodeURIComponentSafe(raw)
        }
    }
    return null
}

/** decodeURIComponent 包装（非法转义序列时原样返回，不抛）。 */
private fun decodeURIComponentSafe(raw: String): String = try {
    decodeURIComponent(raw.replace("+", " "))
} catch (ignored: Throwable) {
    raw
}

private external fun decodeURIComponent(encoded: String): String
